import { requestHelper } from '../helpers/request';

const httpMixin = {
  methods: {
    request: requestHelper,
    openInNewTab(url) {
      const link = document.createElement('a');
      link.href = url;
      link.id = 'new-tab-link';
      link.target = '_blank';
      document.body.appendChild(link);

      // need to wait to send to new tab, not window
      // find another way
      setTimeout(() => {
        link.click();
        link.remove();
      }, 0);
    },
  },
};

export { httpMixin };
